import React, { useState, useContext } from 'react';
import { Dropdown } from 'react-bootstrap';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faSlidersH,
    faChevronDown,
    faCheck,
    faTimes,
    faTag,
    faFilePdf,
    faSpinner,
    faFilter,
    faUser,
    faCalendarAlt,
    faBuilding
} from '@fortawesome/free-solid-svg-icons';
import {
    TicketsDateFilter,
    AgentFilterSelect
} from '../../TicketsView/componentes';
import ClientFilterSelect from './ClientFilterSelect';

const ReportFilterBar = ({
    statusFilter,
    onStatusChange,
    counts,
    dateFilter,
    onDateChange,
    selectedAgentId,
    onAgentChange,
    agents,
    idUsuario,
    nombreCompleto,
    isLoadingAgents,
    selectedClientId,
    onClientChange,
    searchTerm,
    onSearchChange,
    isMobile,
    onExportPdf,
    isExporting,
    totalRegistros
}) => {
    const { config: { isDark } = {} } = useContext(AppContext);
    const [showBottomSheet, setShowBottomSheet] = useState(false);

    const statusOptions = [
        { id: 'todos', label: 'Todos los estados', shortLabel: 'Todos los Estados', count: counts?.todos, dotColor: isDark ? '#94a3b8' : '#64748b' },
        { id: '1', label: 'Pendientes', shortLabel: 'Pendientes', count: counts?.pendientes, dotColor: '#f59e0b' },
        { id: '3', label: 'En Progreso', shortLabel: 'En Progreso', count: counts?.enProgreso, dotColor: '#3b82f6' },
        { id: '2', label: 'Resueltos', shortLabel: 'Resueltos', count: counts?.cerrados, dotColor: '#10b981' },
        { id: 'combinados', label: 'Combinados', shortLabel: 'Combinados', count: counts?.combinados, dotColor: '#8b5cf6' }
    ];

    const currentStatusOption = statusOptions.find(opt => opt.id === statusFilter) || statusOptions[0];
    const isStatusFiltered = statusFilter !== 'todos';

    // 1. Diseño Móvil (Buscador + Botón Filtros -> Activa Bottom Sheet)
    const renderMobileView = () => (
        <div className="mb-3">
            {/* Barra superior móvil: Buscador + Botón Filtros */}
            <div className="d-flex align-items-center gap-2 w-100">
                <div className="position-relative flex-grow-1" style={{ minWidth: 0 }}>
                    <input
                        type="text"
                        className="form-control form-control-sm ps-4 pe-4 rounded-pill shadow-none"
                        placeholder="Buscar en resultados..."
                        value={searchTerm}
                        onChange={e => onSearchChange(e.target.value)}
                        style={{
                            backgroundColor: isDark ? '#1e293b' : '#ffffff',
                            borderColor: isDark ? '#233142' : '#e2e8f0',
                            color: isDark ? '#f8fafc' : '#334155',
                            height: '38px',
                            fontSize: '0.82rem'
                        }}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        className="position-absolute text-muted"
                        style={{
                            left: '14px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontSize: '0.78rem',
                            pointerEvents: 'none'
                        }}
                    />
                    {searchTerm && (
                        <button
                            type="button"
                            onClick={() => onSearchChange('')}
                            className="btn btn-link position-absolute p-0 text-muted border-0 shadow-none"
                            style={{
                                right: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                fontSize: '0.75rem'
                            }}
                            title="Limpiar búsqueda"
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    )}
                </div>

                <button
                    type="button"
                    onClick={() => setShowBottomSheet(true)}
                    className="btn btn-sm px-3 rounded-pill d-inline-flex align-items-center gap-2 shadow-none flex-shrink-0"
                    style={{
                        height: '38px',
                        backgroundColor: isDark ? '#1e293b' : '#ffffff',
                        border: isDark ? '1px solid #334155' : '1px solid #e2e8f0',
                        color: isDark ? '#cbd5e1' : '#334155',
                        fontSize: '0.82rem',
                        fontWeight: 600
                    }}
                    title="Abrir Opciones y Filtros"
                >
                    <FontAwesomeIcon icon={faSlidersH} style={{ fontSize: '0.78rem', color: '#0d9488' }} />
                    <span>Opciones</span>
                </button>
            </div>

            {showBottomSheet && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center"
                    style={{
                        backgroundColor: 'rgba(15, 23, 42, 0.55)',
                        backdropFilter: 'blur(3px)',
                        zIndex: 1080,
                        animation: 'fadeIn 0.2s ease-out'
                    }}
                    onClick={() => setShowBottomSheet(false)}
                >
                    <div
                        className="w-100 p-3 rounded-top-4 shadow-lg border-top"
                        style={{
                            maxWidth: '500px',
                            backgroundColor: isDark ? '#0f172a' : '#f8fafc',
                            borderColor: isDark ? '#334155' : '#e2e8f0',
                            maxHeight: '85vh',
                            overflowY: 'auto',
                            animation: 'slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        {/* Pull Bar Indicator */}
                        <div className="d-flex justify-content-center mb-2">
                            <div
                                style={{
                                    width: '38px',
                                    height: '4px',
                                    borderRadius: '2px',
                                    backgroundColor: isDark ? '#475569' : '#cbd5e1'
                                }}
                            />
                        </div>

                        {/* Header Bottom Sheet */}
                        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom"
                            style={{ borderColor: isDark ? '#1e293b' : '#e2e8f0' }}>
                            <div className="d-flex align-items-center gap-2">
                                <FontAwesomeIcon icon={faSlidersH} style={{ color: '#0d9488', fontSize: '0.9rem' }} />
                                <h6 className="fw-bold mb-0" style={{ color: isDark ? '#f8fafc' : '#0f172a', fontSize: '0.95rem' }}>
                                    Opciones y Filtros
                                </h6>
                            </div>
                            <button
                                type="button"
                                onClick={() => setShowBottomSheet(false)}
                                className="btn btn-sm p-1 rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                                style={{
                                    width: '28px',
                                    height: '28px',
                                    backgroundColor: isDark ? '#1e293b' : '#e2e8f0',
                                    color: isDark ? '#cbd5e1' : '#64748b'
                                }}
                            >
                                <FontAwesomeIcon icon={faTimes} style={{ fontSize: '0.82rem' }} />
                            </button>
                        </div>

                        {/* Sección 1: Acciones Rápidas / Exportar */}
                        {onExportPdf && (
                            <div className="mb-4">
                                <div
                                    className="text-uppercase fw-bold mb-2"
                                    style={{
                                        fontSize: '0.68rem',
                                        letterSpacing: '0.05em',
                                        color: isDark ? '#94a3b8' : '#64748b'
                                    }}
                                >
                                    EXPORTACIÓN DE PDF
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-danger w-100 d-flex align-items-center justify-content-center gap-2 py-2 fw-semibold shadow-none"
                                    onClick={() => {
                                        onExportPdf();
                                        setShowBottomSheet(false);
                                    }}
                                    disabled={isExporting || totalRegistros === 0}
                                    style={{ borderRadius: '10px', fontSize: '0.88rem' }}
                                >
                                    <FontAwesomeIcon
                                        icon={isExporting ? faSpinner : faFilePdf}
                                        spin={isExporting}
                                    />
                                    <span>{isExporting ? 'Generando PDF...' : 'Exportar PDF'}</span>
                                </button>
                            </div>
                        )}

                        {/* Sección 2: Parámetros de Búsqueda */}
                        <div className="mb-3">
                            <div
                                className="text-uppercase fw-bold mb-2"
                                style={{
                                    fontSize: '0.68rem',
                                    letterSpacing: '0.05em',
                                    color: isDark ? '#94a3b8' : '#64748b'
                                }}
                            >
                                FILTROS DE BÚSQUEDA
                            </div>

                            <div className="d-flex flex-column gap-3">
                                {/* Cliente */}
                                <div>
                                    <label
                                        className="form-label mb-1 fw-medium d-flex align-items-center gap-2"
                                        style={{ fontSize: '0.78rem', color: isDark ? '#cbd5e1' : '#475569' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faBuilding}
                                            style={{ fontSize: '0.74rem', color: isDark ? '#6366f1' : '#4f46e5' }}
                                        />
                                        <span>Cliente</span>
                                    </label>
                                    <ClientFilterSelect
                                        variant="chip"
                                        className="w-100"
                                        selectedClientId={selectedClientId}
                                        onSelectClient={onClientChange}
                                    />
                                </div>

                                {/* Asesor asignado */}
                                <div>
                                    <label
                                        className="form-label mb-1 fw-medium d-flex align-items-center gap-2"
                                        style={{ fontSize: '0.78rem', color: isDark ? '#cbd5e1' : '#475569' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faUser}
                                            style={{ fontSize: '0.74rem', color: isDark ? '#38bdf8' : '#0284c7' }}
                                        />
                                        <span>Asesor asignado</span>
                                    </label>
                                    <AgentFilterSelect
                                        variant="chip"
                                        className="w-100"
                                        selectedAgentId={selectedAgentId}
                                        onSelectAgent={onAgentChange}
                                        agents={agents}
                                        currentUserId={idUsuario}
                                        currentUserName={nombreCompleto}
                                        isLoadingAgents={isLoadingAgents}
                                    />
                                </div>

                                {/* Rango de fecha */}
                                <div>
                                    <label
                                        className="form-label mb-1 fw-medium d-flex align-items-center gap-2"
                                        style={{ fontSize: '0.78rem', color: isDark ? '#cbd5e1' : '#475569' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCalendarAlt}
                                            style={{ fontSize: '0.74rem', color: isDark ? '#94a3b8' : '#64748b' }}
                                        />
                                        <span>Filtros por fecha</span>
                                    </label>
                                    <TicketsDateFilter
                                        variant="chip"
                                        className="w-100"
                                        dateFilter={dateFilter}
                                        onChangeDateFilter={onDateChange}
                                        showIcon={false}
                                    />
                                </div>

                                {/* Estado del ticket */}
                                <div>
                                    <label
                                        className="form-label mb-1 fw-medium d-flex align-items-center gap-2"
                                        style={{ fontSize: '0.78rem', color: isDark ? '#cbd5e1' : '#475569' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faTag}
                                            style={{
                                                fontSize: '0.74rem',
                                                color: isStatusFiltered
                                                    ? (isDark ? '#fbbf24' : '#d97706')
                                                    : '#f59e0b'
                                            }}
                                        />
                                        <span>Estado del ticket</span>
                                    </label>
                                    <Dropdown className="w-100">
                                        <Dropdown.Toggle
                                            as="div"
                                            role="button"
                                            tabIndex={0}
                                            className="d-flex align-items-center justify-content-between px-3 py-2 rounded-pill shadow-none dropdown-caret-none w-100"
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: isStatusFiltered
                                                    ? (isDark ? 'rgba(245, 158, 11, 0.15)' : '#fef3c7')
                                                    : (isDark ? '#1e293b' : '#ffffff'),
                                                color: isStatusFiltered
                                                    ? (isDark ? '#fbbf24' : '#b45309')
                                                    : (isDark ? '#cbd5e1' : '#334155'),
                                                border: isStatusFiltered
                                                    ? (isDark ? '1px solid rgba(245, 158, 11, 0.35)' : '1px solid #fde68a')
                                                    : (isDark ? '1px solid #334155' : '1px solid #e2e8f0'),
                                                fontSize: '0.82rem',
                                                fontWeight: 500
                                            }}
                                        >
                                            <span>{statusFilter === 'todos' ? 'Todos los Estados' : currentStatusOption.shortLabel}</span>
                                            <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '0.68rem', opacity: 0.7 }} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                            className={`shadow-lg border py-1 w-100 ${isDark ? 'bg-dark' : 'bg-white'}`}
                                            style={{
                                                maxHeight: '260px',
                                                overflowY: 'auto',
                                                zIndex: 1090,
                                                borderColor: isDark ? '#334155' : '#e2e8f0'
                                            }}
                                        >
                                            {statusOptions.map(opt => {
                                                const isSelected = statusFilter === opt.id;
                                                return (
                                                    <Dropdown.Item
                                                        key={opt.id}
                                                        as="button"
                                                        type="button"
                                                        onClick={() => onStatusChange(opt.id)}
                                                        className="d-flex align-items-center justify-content-between px-3 py-2 border-0"
                                                        style={{
                                                            backgroundColor: isSelected
                                                                ? (isDark ? 'rgba(56, 189, 248, 0.12)' : 'rgba(2, 132, 199, 0.08)')
                                                                : 'transparent',
                                                            color: isSelected
                                                                ? (isDark ? '#38bdf8' : '#0284c7')
                                                                : (isDark ? '#cbd5e1' : '#334155'),
                                                            fontSize: '0.82rem',
                                                            fontWeight: isSelected ? 600 : 500
                                                        }}
                                                    >
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span
                                                                style={{
                                                                    display: 'inline-block',
                                                                    width: '8px',
                                                                    height: '8px',
                                                                    borderRadius: '50%',
                                                                    backgroundColor: opt.dotColor
                                                                }}
                                                            />
                                                            <span>{opt.label}</span>
                                                        </div>
                                                        <span
                                                            className="badge rounded-pill px-2 py-0.5"
                                                            style={{
                                                                fontSize: '0.70rem',
                                                                backgroundColor: isSelected
                                                                    ? '#0284c7'
                                                                    : (isDark ? '#1e293b' : '#f1f5f9'),
                                                                color: isSelected ? '#ffffff' : (isDark ? '#94a3b8' : '#64748b')
                                                            }}
                                                        >
                                                            {opt.count ?? 0}
                                                        </span>
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>

                        {/* Botón Aplicar / Cerrar */}
                        <div className="mt-4">
                            <button
                                type="button"
                                className="btn btn-primary w-100 py-2 fw-semibold shadow-none"
                                style={{ borderRadius: '10px', fontSize: '0.88rem' }}
                                onClick={() => setShowBottomSheet(false)}
                            >
                                Ver resultados
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

    // 2. Diseño Escritorio
    const renderDesktopView = () => (
        <div
            className="rounded-3 p-3 mb-3 border"
            style={{
                backgroundColor: isDark ? '#121e2d' : '#ffffff',
                borderColor: isDark ? '#233142' : '#e2e8f0'
            }}
        >
            <div className="row g-2 align-items-center">
                {/* Menú Desplegable de Filtro por Estado */}
                <div className="col-auto">
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            type="button"
                            className="btn btn-sm d-flex align-items-center justify-content-between border shadow-none px-3 py-2 rounded-2 transition-base dropdown-caret-none"
                            style={{
                                backgroundColor: isDark ? '#121e2d' : '#ffffff',
                                borderColor: statusFilter !== 'todos'
                                    ? (isDark ? '#38bdf8' : '#0284c7')
                                    : (isDark ? '#233142' : '#d8e2ef'),
                                color: statusFilter !== 'todos'
                                    ? (isDark ? '#38bdf8' : '#0284c7')
                                    : (isDark ? '#f9fafd' : '#0f172a'),
                                fontSize: '0.82rem',
                                fontWeight: 600,
                                minHeight: '38px',
                                cursor: 'pointer'
                            }}
                            title="Filtrar por estado del ticket"
                        >
                            <div className="d-flex align-items-center text-truncate">
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="me-2"
                                    style={{
                                        color: statusFilter !== 'todos'
                                            ? (isDark ? '#38bdf8' : '#0284c7')
                                            : (isDark ? '#94a3b8' : '#64748b'),
                                        fontSize: '0.75rem',
                                        flexShrink: 0
                                    }}
                                />
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: '7px',
                                        height: '7px',
                                        borderRadius: '50%',
                                        backgroundColor: currentStatusOption.dotColor,
                                        marginRight: '6px',
                                        flexShrink: 0
                                    }}
                                />
                                <span className="text-truncate">{currentStatusOption.shortLabel}</span>
                            </div>
                            <div className="d-flex align-items-center gap-1 ms-2 flex-shrink-0">
                                <span
                                    className="badge rounded-pill px-2 py-0.5"
                                    style={{
                                        fontSize: '0.70rem',
                                        fontWeight: 600,
                                        backgroundColor: isDark ? '#1e293b' : '#e2e8f0',
                                        color: isDark ? '#cbd5e1' : '#475569'
                                    }}
                                >
                                    {currentStatusOption.count ?? 0}
                                </span>
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    style={{ fontSize: '0.65rem', color: isDark ? '#94a3b8' : '#64748b' }}
                                />
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                            className="shadow-lg border p-1"
                            style={{
                                minWidth: '220px',
                                backgroundColor: isDark ? '#121e2d' : '#ffffff',
                                borderColor: isDark ? '#233142' : '#e2e8f0',
                                color: isDark ? '#f9fafd' : '#0f172a',
                                zIndex: 1050
                            }}
                        >
                            <div
                                className="text-uppercase fw-semibold px-2 py-1 mb-1 border-bottom"
                                style={{
                                    fontSize: '0.66rem',
                                    color: isDark ? '#94a3b8' : '#64748b',
                                    borderColor: isDark ? '#233142' : '#f1f5f9'
                                }}
                            >
                                Filtrar por Estado
                            </div>
                            {statusOptions.map(opt => {
                                const isSelected = statusFilter === opt.id;
                                return (
                                    <Dropdown.Item
                                        key={opt.id}
                                        as="button"
                                        type="button"
                                        onClick={() => onStatusChange(opt.id)}
                                        className="d-flex align-items-center justify-content-between px-2 py-2 rounded-1 border-0"
                                        style={{
                                            backgroundColor: isSelected
                                                ? (isDark ? 'rgba(56, 189, 248, 0.12)' : 'rgba(2, 132, 199, 0.08)')
                                                : 'transparent',
                                            color: isSelected
                                                ? (isDark ? '#38bdf8' : '#0284c7')
                                                : (isDark ? '#cbd5e1' : '#334155'),
                                            fontSize: '0.82rem',
                                            fontWeight: isSelected ? 600 : 500,
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: '8px',
                                                    height: '8px',
                                                    borderRadius: '50%',
                                                    backgroundColor: opt.dotColor
                                                }}
                                            />
                                            <span>{opt.label}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <span
                                                className="badge rounded-pill px-2 py-0"
                                                style={{
                                                    fontSize: '0.70rem',
                                                    fontWeight: 600,
                                                    backgroundColor: isSelected
                                                        ? '#0284c7'
                                                        : (isDark ? '#1e293b' : '#f1f5f9'),
                                                    color: isSelected ? '#ffffff' : (isDark ? '#94a3b8' : '#64748b')
                                                }}
                                            >
                                                {opt.count ?? 0}
                                            </span>
                                            {isSelected && (
                                                <FontAwesomeIcon
                                                    icon={faCheck}
                                                    style={{
                                                        fontSize: '0.72rem',
                                                        color: isDark ? '#38bdf8' : '#0284c7'
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* Filtro de Cliente */}
                <div className="col-auto ms-auto report-filter-client-wrapper">
                    <ClientFilterSelect
                        selectedClientId={selectedClientId}
                        onSelectClient={onClientChange}
                    />
                </div>

                {/* Filtro de Asesor */}
                <div className="col-auto">
                    <AgentFilterSelect
                        variant="default"
                        selectedAgentId={selectedAgentId}
                        onSelectAgent={onAgentChange}
                        agents={agents}
                        currentUserId={idUsuario}
                        currentUserName={nombreCompleto}
                        isLoadingAgents={isLoadingAgents}
                    />
                </div>

                {/* Filtro de Fechas */}
                <div className="col-auto">
                    <TicketsDateFilter
                        variant="default"
                        dateFilter={dateFilter}
                        onChangeDateFilter={onDateChange}
                    />
                </div>

                {/* Buscador */}
                <div className="col-auto">
                    <div className="position-relative" style={{ minWidth: '220px' }}>
                        <input
                            type="text"
                            className="form-control form-control-sm ps-4 pe-4"
                            placeholder="Buscar en resultados..."
                            value={searchTerm}
                            onChange={e => onSearchChange(e.target.value)}
                            style={{
                                backgroundColor: isDark ? '#1e293b' : '#ffffff',
                                borderColor: isDark ? '#233142' : '#e2e8f0',
                                color: isDark ? '#f8fafc' : '#334155',
                                height: '38px',
                                fontSize: '0.82rem'
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            className="position-absolute text-muted"
                            style={{
                                left: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                fontSize: '0.75rem',
                                pointerEvents: 'none'
                            }}
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                onClick={() => onSearchChange('')}
                                className="btn btn-link position-absolute p-0 text-muted border-0 shadow-none"
                                style={{
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    fontSize: '0.75rem'
                                }}
                                title="Limpiar búsqueda"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    if (isMobile === true) {
        return renderMobileView();
    }
    if (isMobile === false) {
        return renderDesktopView();
    }

    return (
        <>
            <div className="d-md-none">{renderMobileView()}</div>
            <div className="d-none d-md-block">{renderDesktopView()}</div>
        </>
    );
};

export default ReportFilterBar;